import { NgModule } from "@angular/core";
import { TabulationComponent } from "./tabulation.component";
import { SharedModule } from "lib-trend-core";
import { TabulationModalComponent } from './tabulation-modal/tabulation-modal.component';

@NgModule({
  imports: [SharedModule],
  declarations: [TabulationComponent, TabulationModalComponent],
  exports: [TabulationComponent, TabulationModalComponent],
})

export class TabulationModule { }
